const getters = {
  token: state => state.user.token,
  refreshToken: state => state.user.refreshToken,
  loggedUser: state => state.user.loggedUser,

  searchResults: state => state.tracking.searchResults,
  selectedCompany: state => state.tracking.company,
  selectedCompanies: state => state.tracking.companies,

  searchText: state => state.tracking.searchText,

  cases: state => state.crm.cases,
  newCases: state => state.crm.newCases,
  selectedCase: state => state.crm.selectedCase,

  supporters: state => state.crm.supporters,

  directionByAirLines: state => state.crm.directionByAirLines,

  accountCRM: state => state.crm.accountCRM,

  historyMessages: state => state.tracking.historyMessages,
  availableMessages: state => state.tracking.availableMessages,

  userGroup: state => state.crmBitrix.userGroup
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js